/**
 *
 * Elastic for SIEM
 *
 */

import React from 'react';

import { AddElasticForSIEM } from 'containers/Setup/Integrations/Components/IntegrationsWizard/SIEM/Elastic/AddElasticForSIEM';
import { EditElasticForSIEM } from 'containers/Setup/Integrations/Components/IntegrationsWizard/SIEM/Elastic/EditElasticForSIEM';
import { useIntegrationsContext } from 'containers/Setup/Integrations/context/context';

export const Elastic = () => {
  const { actionType } = useIntegrationsContext();

  return actionType === 'Add' ? <AddElasticForSIEM /> : <EditElasticForSIEM />;
};
